import { PaymentElement, useElements } from "@stripe/react-stripe-js";
import React, { ReactElement, useEffect } from "react";
import { PaymentMethodState } from "../usePaymentMethodState";
import { SelectablePaymentMethodEnum } from "config/site";

interface StripeComponentProps {
  billingDetails: { name: string; email: string; phone: string };
  paymentMethod: SelectablePaymentMethodEnum;
  setPaymentMethod: (paymentMethod: SelectablePaymentMethodEnum) => void;
  setPaymentMethodState: ({ isValid, data }: PaymentMethodState) => void;
}

function StripeComponent({
  billingDetails,
  paymentMethod,
  setPaymentMethod,
  setPaymentMethodState,
}: StripeComponentProps): ReactElement {
  const elements = useElements();

  useEffect(() => {
    if (paymentMethod !== SelectablePaymentMethodEnum.Stripe) {
      elements?.getElement("payment")?.collapse();
    }
  }, [paymentMethod, elements]);

  return (
    <PaymentElement
      options={{
        layout: {
          type: "accordion",
          defaultCollapsed:
            paymentMethod !== SelectablePaymentMethodEnum.Stripe,
        },
        defaultValues: {
          billingDetails,
        },
        fields: {
          billingDetails: {
            name: "never",
            email: "never",
            phone: "auto",
            address: "auto",
          },
        },
      }}
      onFocus={() => {
        setPaymentMethod(SelectablePaymentMethodEnum.Stripe);
      }}
      onChange={(e) => {
        if (paymentMethod === SelectablePaymentMethodEnum.Stripe) {
          setPaymentMethodState({
            isValid: e.complete,
            data: { type: e.value.type },
          });
        }
      }}
    />
  );
}

export default StripeComponent;
